import { HTMLAttributes, forwardRef } from 'react';

import { cn } from '../../helpers/shadCnUtils';

const Chip = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement> & {
    children: React.ReactNode;
    className?: string;
  }
>(({ children, className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(`flex w-fit items-center gap-1 rounded bg-red-100 px-2 py-0.5 text-xs text-gray-600`, className)}
      {...props}
    >
      {children}
    </div>
  );
});

Chip.displayName = 'Chip';

export default Chip;
